// Delte formateringshjelpere

// Tolk tall trygt (felt kan være string, tomt eller null)
export function num(v) {
  if (v == null || v === '') return null;
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : null;
}

// Vekt: auto-konvertering. Under 1000 g vises som gram, ellers kg.
// Tar imot både tall og string (rå skjemaverdi) og returnerer '' for tom/ugyldig verdi.
export function fmtWeight(value) {
  const grams = num(value);
  if (grams == null) return '';
  if (grams >= 1000) {
    return `${(grams / 1000).toLocaleString('no-NO', { maximumFractionDigits: 2 })} kg`;
  }
  return `${grams.toLocaleString('no-NO')} g`;
}
